// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { requiredValueMustBeWithinMaxLength } from 'validators/common'

const validateNewCommentForm = v => {
  const err = {}

  err.comment = requiredValueMustBeWithinMaxLength(v.comment, 200)

  return err
}

export default validateNewCommentForm
